import React, { useEffect, useState } from "react";
import { Sidebar } from "flowbite-react";
import * as HiIcons from "react-icons/hi";
import * as IoIcons from "react-icons/io5";
import * as MdIcons from "react-icons/md";
import { Link } from "react-router-dom";
import {
  useGetCampusQuery,
  useGetModulesByClusterQuery,
  useGetStudentByEmailIdQuery,
} from "../../../graphql/generated.tsx";


function LeftSideBar({ onSidebarToggle }) {
  const [currentPage, setCurrentPage] = useState("");
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const [hoverEnabled, setHoverEnabled] = useState(true);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const email = JSON.parse(localStorage.getItem("user"))?.email;
  const { data: student } = useGetStudentByEmailIdQuery({
    variables: { email },
  });

  const studentDetails = student?.getStudentByEmailId;
  const primaryClusterId = studentDetails?.clusterIds?.[0];

  const { data: campusData } = useGetCampusQuery({
    variables: { id: studentDetails?.campusId },
    skip: !studentDetails?.campusId,
  });

  const campusName = campusData?.campus?.name;

  const { data: clusterModulesData } = useGetModulesByClusterQuery({
    variables: { campusName, clusterId: primaryClusterId },
    skip: !campusName || !primaryClusterId,
  });

  const hasAssignedModules =
    (clusterModulesData?.getModulesByCluster?.length || 0) > 0;

  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, []);

  const handleMouseEnter = () => {
    if (hoverEnabled) {
      setSidebarExpanded(true);
    }
  };

  const handleMouseLeave = () => {
    setSidebarExpanded(false);
    setHoverEnabled(true); 
  }

  const handleHamburgerClick = () => {
   
    setMobileSidebarOpen((prev) => !prev);
    setSidebarExpanded(true); 
    setHoverEnabled(false);
  };

  const handleNavItemClick = () => {
    if (!isMobileOrTablet) {
      setSidebarExpanded(false);
      setHoverEnabled(false); 
    } else {
      setMobileSidebarOpen(false);
      setSidebarExpanded(false);
      setHoverEnabled(false);
    }
  };

  const customTheme = {
    root: {
      base: "bg-white",
      inner: "bg-white",
    },
  };

  const [isMobileOrTablet, setIsMobileOrTablet] = useState(
    window.innerWidth <= 1024
  );
  useEffect(() => {
    const handleResize = () => setIsMobileOrTablet(window.innerWidth <= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Keep main content aligned with sidebar width (collapsed vs expanded)
  useEffect(() => {
    const width = (isMobileOrTablet ? mobileSidebarOpen : sidebarExpanded)
      ? "14rem"
      : "4rem";
    document.documentElement.style.setProperty("--student-sidebar-width", width);
  }, [sidebarExpanded, mobileSidebarOpen, isMobileOrTablet]);

  // Notify parent about sidebar state for mobile/tablet
  useEffect(() => {
    if (onSidebarToggle && isMobileOrTablet) {
      onSidebarToggle(mobileSidebarOpen);
    }
  }, [mobileSidebarOpen, isMobileOrTablet, onSidebarToggle]);

  return (
    <div className="h-full lg:w-12 lg:flex-shrink-0">
      <Sidebar
        collapsed={isMobileOrTablet ? !mobileSidebarOpen : !sidebarExpanded}
        theme={customTheme}
        onMouseEnter={!isMobileOrTablet ? handleMouseEnter : undefined}
        onMouseLeave={!isMobileOrTablet ? handleMouseLeave : undefined}
        className={`fixed top-0 left-0 z-20 flex flex-col flex-shrink-0 h-full p-4 pt-16 duration-300 border-r border-gray-200 lg:flex transition-all dark:border-gray-700 bg-primary`}
        style={{
          width: (isMobileOrTablet ? mobileSidebarOpen : sidebarExpanded) ? "14rem" : "4rem",
          transition: "width 0.3s",
        }}
      >
        <Sidebar.Items>
          <Sidebar.ItemGroup className="text-white bg-primary">
           
         {isMobileOrTablet && (
            <div className="mb-2">
             <button
              onClick={handleHamburgerClick}
              className={`w-10 h-10 flex items-center justify-center rounded-lg transition-colors duration-200
              ${mobileSidebarOpen ? "bg-gray-200 text-primary" : "text-white"}`}
            >
              {mobileSidebarOpen ? (
            <HiIcons.HiX className="w-6 h-6" />
             ) : (
            <HiIcons.HiMenuAlt1 className="w-6 h-6" />
            )}
          </button>
  </div>
)}


            <Sidebar.Item
              as={Link}
              to="/dashboard"
              icon={HiIcons.HiChartPie}
              onClick={handleNavItemClick}
              className={`flex items-center text-white ${
                currentPage === "/dashboard"
                  ? "bg-gray-200 !text-primary"
                  : "hover:bg-primary"
              }`}
            >
              {sidebarExpanded && "Dashboard"}
            </Sidebar.Item>

            {studentDetails?.clusterIds?.length > 0 && (
              <Sidebar.Item
                as={Link}
                to={
                  studentDetails?.clusterIds?.length === 1
                    ? `/student/courses/${studentDetails?.clusterIds?.[0]}`
                    : "/student/courses"
                }
                icon={IoIcons.IoBookSharp}
                onClick={handleNavItemClick}
                className={`flex items-center text-white ${
                  currentPage.startsWith("/student/courses")
                    ? "bg-gray-200 !text-primary"
                    : "hover:bg-primary"
                }`}
              >
                {sidebarExpanded && "Courses"}
              </Sidebar.Item>
            )}

            <Sidebar.Item
              as={Link}
              to="/assignments"
              icon={HiIcons.HiViewBoards}
              onClick={handleNavItemClick}
              className={`flex items-center text-white ${
                currentPage.startsWith("/assignments")
                  ? "bg-gray-200 !text-primary"
                  : "hover:bg-primary"
              }`}
            >
              {sidebarExpanded && "Assignments"}
            </Sidebar.Item>

            <Sidebar.Item
              as={Link}
              to="/student/contests"
              icon={HiIcons.HiSparkles}
              onClick={handleNavItemClick}
              className={`flex items-center text-white ${
                currentPage.startsWith("/student/contests")
                  ? "bg-gray-200 !text-primary"
                  : "hover:bg-primary"
              }`}
            >
              {sidebarExpanded && "Contests"}
            </Sidebar.Item>

            {studentDetails?.clusterIds?.length > 0 && hasAssignedModules && (
              <Sidebar.Item
                as={Link}
                to="/practice-lab"
                icon={MdIcons.MdTaskAlt}
                onClick={handleNavItemClick}
                className={`flex items-center text-white ${
                  currentPage.startsWith("/practice-lab")
                    ? "bg-gray-200 !text-primary"
                    : "hover:bg-primary"
                }`}
              >
                {sidebarExpanded && "Practice Lab"}
              </Sidebar.Item>
            )}

            <Sidebar.Item
              as={Link}
              to="/student/assignment-leaderboard"
              icon={MdIcons.MdAssignment}
              onClick={handleNavItemClick}
              className={`flex items-center text-white ${
                currentPage.startsWith("/student/assignment-leaderboard")
                  ? "bg-gray-200 !text-primary"
                  : "hover:bg-primary"
              }`}
            >
              {sidebarExpanded && "Leaderboard"}
            </Sidebar.Item>

            <Sidebar.Item
              as={Link}
              to="/student/my-profile"
              icon={IoIcons.IoSettingsOutline}
              onClick={handleNavItemClick}
              className={`flex items-center text-white ${
                currentPage.startsWith("/student/my-profile")
                  ? "bg-gray-200 !text-primary"
                  : "hover:bg-primary"
              }`}
            >
              {sidebarExpanded && "Settings"}
            </Sidebar.Item>
          </Sidebar.ItemGroup>
        </Sidebar.Items>
      </Sidebar>
    </div>
  );
}

export default LeftSideBar;
